var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33332 2.33341C8.00832 2.33341 11 5.32508 11 9.00008C11 12.6751 8.00832 15.6667 4.33332 15.6667C4.04999 15.6667 3.76666 15.6501 3.49166 15.6084C5.08332 13.8084 5.99999 11.4584 5.99999 9.00008C5.99999 6.54175 5.08332 4.19175 3.49166 2.39175C3.76666 2.35008 4.04999 2.33341 4.33332 2.33341ZM4.33332 0.666748C2.81666 0.666748 1.39166 1.08341 0.166656 1.79175C2.65832 3.23341 4.33332 5.91675 4.33332 9.00008C4.33332 12.0834 2.65832 14.7667 0.166656 16.2084C1.39166 16.9167 2.81666 17.3334 4.33332 17.3334C8.93332 17.3334 12.6667 13.6001 12.6667 9.00008C12.6667 4.40008 8.93332 0.666748 4.33332 0.666748Z",
    fill: "var(--font-01)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.e9bb9ae09783fa9f5e535e36a15a9b01.svg";
export { ForwardRef as ReactComponent };